import { clearThreadsCache } from 'bundles/discussions/actions/ThreadsActions';
import * as ThreadDetailsUtils from 'bundles/discussions/api/threadDetailsUtils';

/**
 * Utility function for dispatching errors to store - not exported.
 */
const errorAction = function (actionContext: $TSFixMe, error: $TSFixMe) {
  actionContext.dispatch('THREAD_SETTINGS_ERROR', error);
};

export const addThread = function (actionContext: $TSFixMe, threadInfo: $TSFixMe) {
  actionContext.dispatch('ADD_THREAD', threadInfo);
};

export const closeThread = function (actionContext: $TSFixMe, { questionId, forumType }: $TSFixMe) {
  ThreadDetailsUtils.closeThread(questionId, forumType)
    .then(
      () => {
        actionContext.dispatch('CLOSE_THREAD', questionId);
      },
      (error) => {
        actionContext.executeAction(errorAction, error);
      }
    )
    // @ts-expect-error ts-migrate(2555) FIXME: Expected at least 1 arguments, but got 0.
    .done();
};

export const uncloseThread = function (actionContext: $TSFixMe, { questionId, forumType }: $TSFixMe) {
  ThreadDetailsUtils.uncloseThread(questionId, forumType)
    .then(
      () => {
        actionContext.dispatch('UNCLOSE_THREAD', questionId);
      },
      (error) => {
        actionContext.executeAction(errorAction, error);
      }
    )
    // @ts-expect-error ts-migrate(2555) FIXME: Expected at least 1 arguments, but got 0.
    .done();
};

export const pinThread = function (actionContext: $TSFixMe, { questionId, forumType }: $TSFixMe) {
  ThreadDetailsUtils.pinThread(questionId, forumType)
    .then(
      () => {
        // make sure cache is cleared so that the new pin will show up in threads view
        clearThreadsCache(actionContext);
        actionContext.dispatch('PIN_THREAD', questionId);
      },
      (error) => {
        actionContext.executeAction(errorAction, error);
      }
    )
    // @ts-expect-error ts-migrate(2555) FIXME: Expected at least 1 arguments, but got 0.
    .done();
};

export const unpinThread = function (actionContext: $TSFixMe, { questionId, forumType }: $TSFixMe) {
  ThreadDetailsUtils.unpinThread(questionId, forumType)
    .then(
      () => {
        // make sure cache is cleared so that the pin will no longer show in threads view
        clearThreadsCache(actionContext);
        actionContext.dispatch('UNPIN_THREAD', questionId);
      },
      (error) => {
        actionContext.executeAction(errorAction, error);
      }
    )
    // @ts-expect-error ts-migrate(2555) FIXME: Expected at least 1 arguments, but got 0.
    .done();
};
